(function () {
  function pluralizeSets(count) {
    var lastTwo = count % 100;
    var last = count % 10;
    if (lastTwo >= 11 && lastTwo <= 14) return 'наборів';
    if (last === 1) return 'набір';
    if (last >= 2 && last <= 4) return 'набори';
    return 'наборів';
  }


  function formatGiftPrices(root) {
    root.querySelectorAll('.hm-gifts__product-item .product-card__price span').forEach(function (priceText) {
      if (priceText.children.length || priceText.classList.contains('visually-hidden')) return;

      var currentText = priceText.textContent.trim();
      var currencyMatch = currentText.match(/^UAH\s+(.+)$/);
      if (currencyMatch) priceText.textContent = currencyMatch[1] + ' UAH';
    });
  }

  function initGiftFinder(root) {
    if (root.getAttribute('data-gifts-initialized') === 'true') return;
    root.setAttribute('data-gifts-initialized', 'true');

    var ideaButtons = Array.prototype.slice.call(root.querySelectorAll('[data-gift-idea-button]'));
    var recipientButtons = Array.prototype.slice.call(root.querySelectorAll('[data-gift-recipient-button]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-gift-idea-panel]'));
    var products = Array.prototype.slice.call(root.querySelectorAll('[data-gift-product]'));
    var resetButtons = Array.prototype.slice.call(root.querySelectorAll('[data-gift-reset]'));
    var resultCount = root.querySelector('[data-gift-result-count]');
    var emptyState = root.querySelector('[data-gift-empty]');
    var productGrid = root.querySelector('[data-gift-product-grid]');
    var ideaTrack = root.querySelector('[data-gift-idea-track]');
    var swipePages = Array.prototype.slice.call(root.querySelectorAll('[data-gift-swipe-page]'));
    var state = { idea: 'all', recipient: 'all' };

    formatGiftPrices(root);

    if (!ideaButtons.length || !products.length) return;

    function containsValue(element, attribute, value) {
      if (value === 'all') return true;
      return (element.getAttribute(attribute) || '').split('|').indexOf(value) !== -1;
    }

    function setButtonState(buttons, attribute, value) {
      buttons.forEach(function (button) {
        var isActive = button.getAttribute(attribute) === value;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function updatePanels() {
      panels.forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-gift-idea') !== state.idea;
      });
    }

    function updateResults() {
      var visibleCount = 0;

      products.forEach(function (product) {
        var matchesIdea = containsValue(product, 'data-idea', state.idea);
        var matchesRecipient = containsValue(product, 'data-recipient', state.recipient);
        var isVisible = matchesIdea && matchesRecipient;
        product.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      if (resultCount) resultCount.textContent = visibleCount + ' ' + pluralizeSets(visibleCount);
      if (emptyState) emptyState.hidden = visibleCount !== 0;
      if (productGrid) productGrid.hidden = visibleCount === 0;

      var filtersActive = state.idea !== 'all' || state.recipient !== 'all';
      resetButtons.forEach(function (button) {
        if (button.closest('[data-gift-empty]')) return;
        button.hidden = !filtersActive;
      });
    }

    function setIdea(value) {
      state.idea = value;
      setButtonState(ideaButtons, 'data-gift-idea', value);
      updatePanels();
      updateResults();
    }

    function setRecipient(value) {
      state.recipient = value;
      setButtonState(recipientButtons, 'data-gift-recipient', value);
      updateResults();
    }

    function resetAll() {
      setIdea('all');
      setRecipient('all');
      var allIdeaButton = root.querySelector('[data-gift-idea-button][data-gift-idea="all"]');
      if (allIdeaButton) allIdeaButton.focus();
    }

    function updateSwipeProgress() {
      if (!ideaTrack || !swipePages.length) return;

      var maxScroll = Math.max(0, ideaTrack.scrollWidth - ideaTrack.clientWidth);
      var progress = maxScroll > 0 ? Math.abs(ideaTrack.scrollLeft) / maxScroll : 0;
      var activePage = Math.min(
        swipePages.length - 1,
        Math.max(0, Math.round(progress * (swipePages.length - 1)))
      );

      swipePages.forEach(function (page, index) {
        page.classList.toggle('is-active', index === activePage);
      });
    }

    if (ideaTrack && swipePages.length) {
      var swipeFramePending = false;

      ideaTrack.addEventListener('scroll', function () {
        if (swipeFramePending) return;
        swipeFramePending = true;

        window.requestAnimationFrame(function () {
          updateSwipeProgress();
          swipeFramePending = false;
        });
      }, { passive: true });

      if ('ResizeObserver' in window) {
        var swipeResizeObserver = new ResizeObserver(updateSwipeProgress);
        swipeResizeObserver.observe(ideaTrack);
      }

      window.requestAnimationFrame(updateSwipeProgress);
    }

    ideaButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setIdea(button.getAttribute('data-gift-idea'));
        if (button.scrollIntoView) {
          button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      });
    });

    recipientButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setRecipient(button.getAttribute('data-gift-recipient'));
      });
    });

    resetButtons.forEach(function (button) {
      button.addEventListener('click', resetAll);
    });

    setIdea('all');
    setRecipient('all');
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-home-me-gifts]').forEach(initGiftFinder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
